module.exports = __webpack_public_path__ + "img/logo-faction.f5202e66.jpg";